import React, { forwardRef, Ref } from 'react';
import { ProjectId } from 'api/models';
import {
  RichTextEditor,
  RichTextEditorProps,
} from 'components/atoms/rich-text-editor';
import { OnUserMention } from 'components/molecules/mention';
import { useMentionsData } from 'hooks/use-mentions-data';
import { useOnUserMention } from 'hooks/use-on-user-mention';

interface RteProps extends Omit<RichTextEditorProps, 'mentionData'> {
  projectId: ProjectId;
  handleUserMention?: OnUserMention;
  ref?: React.Ref<RichTextEditor>;
}

export const RTE = forwardRef((props: RteProps, ref: Ref<RichTextEditor>) => {
  const { projectId, handleUserMention, ...restProps } = props;
  const options = {
    enabled: !restProps.disallowMentions,
  };
  const mentionData = useMentionsData(projectId, options);
  const onUserMention = useOnUserMention(projectId, options);

  return (
    <RichTextEditor
      ref={ref}
      {...restProps}
      mentionData={mentionData}
      onUserMention={handleUserMention || onUserMention}
      projectId={projectId}
    />
  );
});
